
<template>
  <div>
    <el-dialog
      :visible.sync="show"
      :show-close="false"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      title="mock模拟数据"
      width="600px"
    >
      <el-form
        ref="form"
        :model="form"
        label-width="70px"
      >
        <el-form-item label="url">
          <el-input v-model="form.url"/>
        </el-form-item>
        <el-form-item label="type">
          <el-select v-model="form.type">
            <el-option
              label="post"
              value="post"
            />
            <el-option
              label="get"
              value="get"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="responseData">
          <el-input
            v-model="form.endData"
            type="textarea"
          />
        </el-form-item>
      </el-form>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="handleClose">取消</el-button>
        <el-button
          type="primary"
          @click="submit"
        >确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
	<script>
  import Mock from 'mockjs';

  export default {
    name: 'env-mock',

    mixins: [],
    data() {
      return {
        show: false,
        form: {
          url: '',
          type: 'post',
          endData: ''
        }
      };
    },
    watch: {
      show(v) {
        if (v) {
          this.form.env = localStorage.getItem('personUrl') || '';
        } else {
          this.$emit('destory');
        }
      }
    },
    mounted() {
    },
    methods: {
      handleClose() {
        this.$emit('close');
      },
      submit() {
        let responseData = JSON.parse(this.form.endData);
        Mock.mock(this.form.url, this.form.type, responseData);
        this.$emit('sure');
      },
    },
  };
	</script>

  <style scoped>
</style>


// WEBPACK FOOTER //
// src/components/develop-person/mock.vue